import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { theme } from '@features/executive-report/domain/theme';
import { Table, TableRow } from '@features/powerpoint';
import { postalCodeToStateName } from '@utils/states';
import {
  INDEX_WIDTH,
  NORMAL_WIDTH,
  ROWS_PER_TABLE,
  headersToTableRow,
  defaultTableOptions,
  cellOptionsByIndex,
  VISIT_INDEX_WIDTH,
} from './table-utils';
import { sortBy } from '@utils/arrays';
import { MetaTableStyle } from '@features/executive-report/domain/meta-table-style';

const headers = ['', 'State', 'Visit Index'].map(header =>
  header.toUpperCase()
);

export const statesTable = (
  stateVisits: CampaignAnalyticsReport['stateVisits'],
  metaTableStyle?: MetaTableStyle
): Table => {
  const topStatesRows: TableRow[] = stateVisits.data
    .toSorted(sortBy('visitIndex', 'desc'))
    .slice(0, ROWS_PER_TABLE)
    .map((stateVisit, index): TableRow => {
      const options = cellOptionsByIndex(
        index,
        Math.min(stateVisits.data.length, ROWS_PER_TABLE),
        metaTableStyle
      );

      return [
        {
          text: (index + 1).toString(),
          options: {
            ...options,
            color: metaTableStyle?.cellFontColor ?? theme.colors.lightBlue,
            align: 'center',
          },
        },
        {
          text:
            (postalCodeToStateName as Record<string, string | undefined>)[
              stateVisit.location
            ] ?? stateVisit.location,
          options: {
            ...options,
            bold: true,
          },
        },
        {
          text: stateVisit.visitIndex.toString(),
          options: {
            ...options,
            align: 'center',
          },
        },
      ];
    });

  return {
    tableRows: [
      headersToTableRow(headers, undefined, metaTableStyle),
      ...topStatesRows,
    ],
    options: {
      ...defaultTableOptions,
      color: metaTableStyle?.cellFontColor ?? defaultTableOptions.color,
      colW: [INDEX_WIDTH, NORMAL_WIDTH, VISIT_INDEX_WIDTH],
    },
  };
};
